export default "__VITE_ASSET__DLguOC1o__"